import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ForgeTooltip } from '@tylertech/forge-react';

const EntityPlusMoreComponent = (props) => {
  const { main, number, toggleId, isTruncated, value } = props;
  const [result, setResult] = React.useState(null);

  useEffect(() => {
    if (value) {
      const _result = [...value];
      _result.shift();
      setResult(_result);
    }
  }, [value]);

  return (
    <>
      {main}{' '}
      {number ? (
        <span>
          {'('}
          <span id={toggleId}  style={{ cursor: 'default', textDecoration: 'underline', color: 'var(--forge-theme-primary)' }} onClick={(e) => e.preventDefault()}>
            +{number} more
          </span>
          {')'}
          {isTruncated===false && <ForgeTooltip anchor={toggleId} position="bottom"> {result?.join(', ')} </ForgeTooltip>}
        </span>
      ) : null}
    </>
  );
};

EntityPlusMoreComponent.propTypes = {
  main: PropTypes.string,
  number: PropTypes.number,
  toggleId: PropTypes.string,
  isTruncated: PropTypes.bool,
  value: PropTypes.array, 
};

export default EntityPlusMoreComponent;
